import { getLifecycle } from 'service/utils';

const BASE_NAME = 'TOURNAMENT';

export const WIN_RESULTS = getLifecycle(BASE_NAME, 'WINS');
